// =============================================================================
// client/src/components/ConfirmModal.jsx | v1.0 | S79 | P9a — W-7(g)
// =============================================================================
// RM's confirm modal (CampaignDashboard.jsx :1130-1143) rebuilt in Tailwind.
//
// Used by the archive confirm (§6.5's verbatim copy) and the batch-unarchive
// confirm in W-9. Deliberately dumb: it renders a question and returns an
// answer. It owns no decision, and it never says what will happen — the caller
// supplies the copy, because the copy is the thing that has been ruled.
// =============================================================================

// `requireTyped` (P9b W-2): the caller supplies a word the operator must type
// before Confirm enables. Used for the evidence-law delete, where a click is
// too cheap for what it destroys. The modal owns the input and the comparison
// so no caller has to reimplement either — and Confirm stays genuinely
// disabled rather than merely looking it.
import { useEffect, useState } from 'react';

export default function ConfirmModal({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  requireTyped = null,
  onConfirm,
  onCancel,
}) {
  const [typed, setTyped] = useState('');

  useEffect(() => { if (!open) setTyped(''); }, [open]);

  if (!open) return null;

  const armed = !requireTyped || typed === requireTyped;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h2 className="font-display font-black text-hunter text-xl mb-2">{title}</h2>
        <p className="text-sm text-silver-mute whitespace-pre-line mb-6">{body}</p>
        {requireTyped && (
          <div className="mb-6">
            <label className="label-dark mb-1 block">
              Type <span className="font-mono font-bold">{requireTyped}</span> to confirm
            </label>
            <input
              className="input"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              placeholder={requireTyped}
              autoFocus
            />
          </div>
        )}
        <div className="flex justify-end gap-3">
          <button type="button" onClick={onCancel} className="btn-secondary">
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={!armed}
            className={`${destructive ? 'btn-primary bg-red-600 hover:bg-red-700' : 'btn-primary'} disabled:opacity-40 disabled:cursor-not-allowed`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
